import { QuestionnaireKind, usesEmbeddedMaterialRenderer } from '../../types/QuestionnaireKind';
import { TaskResource } from './types';

export const getLatestTaskResponseId = (taskResource: TaskResource | undefined): string | null => {
    const firstOutput = taskResource?.output?.[0];
    const outputValue = firstOutput?.valueString || firstOutput?.valueReference?.reference || firstOutput?.value;

    if (!outputValue) {
        return null;
    }

    const value = typeof outputValue === 'string' ? outputValue : outputValue.toString();
    return value.includes('/') ? value.split('/').pop() || null : value;
};

export const shouldLoadTaskResponse = (
    status: string | undefined,
    resourceKind: QuestionnaireKind,
    taskResource: TaskResource | undefined,
): boolean => {
    if (usesEmbeddedMaterialRenderer(resourceKind)) {
        return getLatestTaskResponseId(taskResource) !== null;
    }

    return status !== 'requested';
};
